import React from 'react';

export const CtaButton = ({children, ...props}) => {
  return (
    <button type="button" className="btn btn--cta" {...props}>
      {children}
    </button>
  )
}